import { useLocation } from "react-router-dom";
import "./App.css";
import { AllRoutes } from "./Routes/Routes";
import { Navbar } from "./components/navbar/Navbar";
import { Sidebar } from "./components/sidebar/Sidebar";
function App() {
  const location = useLocation();
  console.log( location.pathname);
  const showNavbar = location.pathname !== "/login";
  return (
    <div >
      {showNavbar && (
        <>
          {" "}
          <Navbar />
          <Sidebar />{" "}
        </>
      )}
      <div style={showNavbar ? { marginLeft: "320px",marginTop:'50px' } : {  }}>
        <AllRoutes />
      </div>
    </div>
  );
}

export default App;
